import { noop } from 'lodash'
import { createContext, RefObject } from 'react'

export interface Section {
  isActive: boolean,
  isValid: boolean,
  ref: RefObject<HTMLSpanElement>,
  sectionId: string,
  title: string,
  isSubSection?: boolean,
}

export interface FormContextType {
  addFormField: (...args: $TSFIXME[]) => $TSFIXME,
  addFormSection: (section: Section) => void,
  fields: $TSFIXME[],
  removeFormField: (...args: $TSFIXME[]) => $TSFIXME,
  removeFormSection: (sectionId: string) => void,
  sections: Section[],
  setActiveSection: (section: Section) => void,
}

export const defaultFormContext: FormContextType = {
  addFormField: noop,
  addFormSection: noop,
  fields: [],
  removeFormField: noop,
  removeFormSection: noop,
  sections: [],
  setActiveSection: noop,
}

/** This context is passed to Sections and Fields so that they can register themselves to the form */
export const FormContext = createContext<FormContextType>(defaultFormContext)
